import {useLocation} from '@github-ui/react-router'

import {repoSidebarLinks} from '../constants/repo-sidebar-links'

interface UseIssuesSidebarStateOptions {
  owner: string
  repo: string
}

export function useIssuesSidebarState({owner: _owner, repo: _repo}: UseIssuesSidebarStateOptions) {
  const {search} = useLocation()

  const searchParams = new URLSearchParams(search)
  const currentQuery = searchParams.get('q')?.trim() ?? ''
  const selectedLink = repoSidebarLinks.find(link => link.query === currentQuery)?.id ?? ''

  return {selectedLink}
}
